import {
  BrandKit,
  InputStyleDefinition,
  Override,
} from "@redotech/redo-model/brand-kit";
import { getInputStyles } from "@redotech/redo-model/brand-kit/utils";
import { CSSProperties, memo } from "react";
import { RedoSingleSelectDropdownInput } from "./arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import * as css from "./brand-kit-dropdown-input.module.css";
import { Text } from "./text";

export interface BrandKitDropdownInputProps<T> {
  brandKit: BrandKit;
  options: Array<{ id: string; name: string }>;
  value: string | null;
  setValue: (value: string) => void;
  override?: Override<InputStyleDefinition>;
  name?: string;
  placeholder?: string;
  required?: boolean;
  label?: string;
  description?: string;
}

export const BrandKitDropdownInput = memo(function BrandKitDropdownInput<T>({
  brandKit,
  options,
  value,
  setValue,
  override,
  name,
  placeholder,
  required,
  label,
  description,
}: BrandKitDropdownInputProps<T>) {
  const style = getInputStyles(brandKit, override);

  const optionOverrideStyles: CSSProperties = { ...style, borderWidth: 0 };

  return (
    <>
      <input
        name={name}
        required={required}
        type="hidden"
        value={value || ""}
      />

      <RedoSingleSelectDropdownInput
        className={css.brandKitDropdownInput}
        dangerousStyleThatShouldOnlyBeUsedForMerchantBranding={style}
        description={description}
        label={label}
        options={
          options.map((opt) => ({
            value: opt.id,
            id: opt.id,
            type: "custom",
            render: <Text style={optionOverrideStyles}>{opt.name}</Text>,
            useWrapper: true,
          })) || []
        }
        optionSelected={(item) => setValue(item.item.value)}
        placeholder={placeholder}
        selectedItem={
          value ? { value, type: "text", text: value, id: value } : undefined
        }
        size="xs"
      />
    </>
  );
});
